import { GAME_ID, REDUX_ACTIONS } from 'a/zoomBoom/data/constants';
import _ from 'lodash';

const initialState = {
  questionId: 0,
  isQuestionInited: false,
  main: {},
  options: [],
  usedIds: [],
};

const questionReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_LEVEL:
      return {
        ...state,
        usedIds: [],
      };

    case REDUX_ACTIONS.INIT_QUESTION: {
      let availableDistractors = [];

      // #region Extract distractors in main group if any. Choose main word and correct word.
      const mainGroup = payload.words[payload.wordGroupIndex];
      const availableWordsInMainGroup = [];

      Object.keys(mainGroup)
        .filter(key => !state.usedIds
          .includes(mainGroup[key].id))
        .forEach((key) => {
          const word = mainGroup[key];
          if (word.distractor) {
            availableDistractors.push(word);
          } else {
            availableWordsInMainGroup.push(word);
          }
        });

      const mainGroupWordsToUse = _.sampleSize(availableWordsInMainGroup, 2);
      const [main, correctOption] = mainGroupWordsToUse;
      // #endregion

      // #region Get distractors from other groups in current level. Take 2 random distractors.
      if (availableDistractors.length === 0) {
        const restGroups = _.without(
          [...new Set(payload.currentLevelWordGroups)], payload.wordGroupIndex,
        );

        availableDistractors = _.flattenDeep(
          restGroups.map(group => payload.words[group]),
        );
      }
      const restWordsToUse = _.sampleSize(availableDistractors, 2).map(word => ({
        ...word,
        isCorrect: false,
      }));

      // #endregion

      const options = _.union([{
        ...correctOption,
        isCorrect: true,
      }], restWordsToUse);
      const usedIds = payload.isSample ? state.usedIds : [
        ...state.usedIds,
        main.id,
        correctOption.id,
      ];
      return {
        ...state,
        questionId: state.questionId + 1,
        isQuestionInited: true,
        main,
        options: _.shuffle(options),
        usedIds,
      };
    }

    case REDUX_ACTIONS.SET_QUESTION:
      return {
        ...state,
        questionId: 0,
        isQuestionInited: true,
        main: payload.main,
        options: payload.options,
      };

    case REDUX_ACTIONS.RESET_QUESTION:
      return {
        ...initialState,
        usedIds: state.usedIds,
      };

    case REDUX_ACTIONS.SELECT_OPTION:
      return {
        ...state,
        options: state.options.map((option) => {
          if (option.id !== payload) {
            return {
              ...option,
              isInTarget: false,
            };
          }
          return {
            ...option,
            isSelected: option.id === payload,
            isInTarget: true,
          };
        }),
      };

    case REDUX_ACTIONS.UNSELECT_OPTION:
      return {
        ...state,
        options: state.options.map(option => ({
          ...option,
          isInTarget: false,
        })),
      };

    case REDUX_ACTIONS.HIGHLIGHT_OPTION:
      return {
        ...state,
        options: state.options.map(option => ({
          ...option,
          isHighlighted: option.id === payload,
        })),
      };

    case REDUX_ACTIONS.UNHIGHLIGHT_OPTION:
      return {
        ...state,
        options: state.options.map(option => ({
          ...option,
          isHighlighted: false,
        })),
      };

    default:
      return state;
  }
};

export default questionReducer;
